import { Component } from '@angular/core';
import { TrelloService } from 'app/trello/services/trello.service';

@Component({
  selector: 'app-home-component',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  constructor(
    private readonly trelloService: TrelloService, // required
  ) {
  }

}
